/*
 *   SIP list filter: All / New SIPs / Old SIPs (include_old param)
 */

import { useEffect, useState } from "react";

import { CheckBoxGroup } from "../FormElements";
import Icon from "../Icon/icon";
import { GradientButton, OutlineButton } from "../Cta";

export const INCLUDE_OLD_FILTER_OPTIONS = [
    { id: "both", label: "All" },
    { id: "new_sip", label: "New SIPs" },
    { id: "old_sip", label: "Old SIPs" },
];

const SipIncludeOldFilterPopup = (props) => {
    const { appliedIncludeOld, onClose, onApply, open } = props;
    const [draft, setDraft] = useState(appliedIncludeOld || "both");

    useEffect(() => {
        if (open) {
            setDraft(appliedIncludeOld || "both");
        }
    }, [open, appliedIncludeOld]);

    const _handleOption = (id) => {
        setDraft(id);
    };

    const _handleClear = () => {
        setDraft("both");
    };

    const _handleFilter = () => {
        onApply(draft);
        onClose();
    };

    return (
        <div className="border-radius-16px z-index-9 border-all border-bright-gray box-shadow-filter padding-24px-all pe-1 bg-white position-absolute right-0 top-8px w-max-content">
            <div className="position-relative pe-4">
                <Icon
                    icon="close"
                    size={24}
                    className="position-absolute e-close top-0 right-20px cursor-pointer e-modal-close-btn"
                    onClick={onClose}
                />
                <div className="container-fluid">
                    <div className="row">
                        <div className="bg-transparent">
                            <p className="color-charleston-green e-poppins-semi-bold e-font-14 line-height-24px mb-2">SIPs</p>
                            <div className="d-flex flex-column gap-12px e-fund-category">
                                {INCLUDE_OLD_FILTER_OPTIONS.map((item, key) => (
                                    <CheckBoxGroup
                                        item={item}
                                        key={key}
                                        selectedType={[draft]}
                                        onHandleClick={_handleOption}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex gap-16px justify-content-end mt-3 pt-3 border-top-1px border-bright-gray pe-4">
                <OutlineButton label="Clear" className="e-font-16" onPress={_handleClear} />
                <GradientButton
                    label="Filter"
                    hide_loader={true}
                    className="e-font-16 padding-12px-tb px-3"
                    onPress={_handleFilter}
                />
            </div>
        </div>
    );
};

export default SipIncludeOldFilterPopup;
